// src/store/features/message/textContentSelectors.js

export const selectIsTextLanguageDetecting = (state) =>
  state.textContent.isTextLanguageDetecting;

export const selectTextLanguageDetectionData = (state) =>
  state.textContent.textLanguageDetectionData;

export const selectTextLanguageDetectionError = (state) =>
  state.textContent.textLanguageDetectionError;

export const selectIsContentGenerating = (state) =>
  state.textContent.isContentGenerating;

export const selectContentGenerationData = (state) =>
  state.textContent.contentGenerationData;

export const selectContentGenerationError = (state) =>
  state.textContent.contentGenerationError;

export const selectIsNerDetecting = (state) => state.textContent.isNerDetecting;

export const selectNerDetectionData = (state) =>
  state.textContent.nerDetectionData;
export const selectNerDetectionError = (state) =>
  state.textContent.nerDetectionError;
export const selectIsInputDisabled = (state) =>
  state.textContent.isInputDisabled;

export const selectSelectedChatId = (state) => state.textContent.selectedChatId;
export const selectCurrentUserChatId = (state) =>
  state.textContent.currentUserChatId;
export const selectCurrentBotChatId = (state) =>
  state.textContent.currentBotChatId;

export const selectDisplayTranscript = (state) =>
  state.textContent.displayTranscript;

export const selectTranscriptType = (state) => state.textContent.transcriptType;

export const selectAccumulatedFinalTranscript = (state) =>
  state.textContent.accumulatedFinalTranscript;

export const selectCurrentInterimTranscript = (state) =>
  state.textContent.currentInterimTranscript;

export const selectCurrentFinalTranscript = (state) =>
  state.textContent.currentFinalTranscript;

export const selectSelectedSocketLanguageData = (state) =>
  state.textContent.selectedSocketLanguageData;

export const selectRecordedBase64Data = (state) =>
  state.textContent.recordedBase64Data;

export const selectSocketFlags = (state) => state.textContent.socketFlags;

export const selectIsSocketRecording = (state) =>
  state.textContent.isSocketRecording;

export const selectIsVoiceFlow = (state) => state.textContent.isVoiceFlow;

export const selectIsSocketDataReadyToSend = (state) =>
  state.textContent.isSocketDataReadyToSend;

// UI
export const selectIsSuggestedQuestionsVisible = (state) =>
  state.textContent.isSuggestedQuestionsVisible;

export const selectIsHideUserInputFields = (state) =>
  state.textContent.isHideUserInputFields;

// 🔒 VoiceFlow Locks
// export const selectVoiceFlowLocks = (state) => state.textContent.voiceFlowLocks;
export const selectVoiceFlowLocks = (chatId) => (state) =>
  state?.textContent?.voiceFlowLocks?.[chatId] ?? false;

export const selectIsVoiceFlowLocked = (chatId) => (state) =>
  chatId ? state.textContent.voiceFlowLocks?.[chatId] || false : false;


export const selectIsTextFlow = (state) => state.textContent.isTextFlow;
export const selectTextFlowLocks = (chatId) => (state) =>
  state?.textContent?.textFlowLocks?.[chatId] ?? false;

export const selectIsTextFlowLocked = (chatId) => (state) =>
  chatId ? state.textContent.textFlowLocks?.[chatId] || false : false;